import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import Spinner from "../Spinner";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import { handleExportClickDriver } from "../exportDriverFile";
import { Button } from "react-bootstrap";
import { Checkbox, Modal } from "antd";
import ReactToPrint from "react-to-print";

import { saveAs } from "file-saver";
import Passenger from "../reports/Passenger";
import ActionButtons from "../Trip/TripsActionButton.js";

import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Edit as EditIcon, 
  Delete as DeleteIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const SubscriberssList = () => {
  const roleData = useContext(RoleContext);

  var role = JSON.parse(roleData);

  const printableRef = useRef(null);
 const navigate = useNavigate();
  const [passengers, setPassengers] = useState([]);
  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  let [loading, setLoading] = useState(true);
  const getPassengers = async () => {
    const response = await axios
      .get("passengers/")
      .then((res) => {
        console.log("===========passengers=ddddaaatta===============", res);
        setPassengers(res.data);
        setLoading(false);
        notify()
      })
      .catch((err) => {
        notifyError();
      });
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this passenger`);
    setDisplayConfirmationModal(true);
  };

  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    console.log(id);
    deletePassenger(id);
    getPassengers();
    setDisplayConfirmationModal(false);
    // getPassengers();
  };
  const deletePassenger = async (id) => {
    const response = await axios.delete("/passenger/" + id, {
      data: { id: id },
    });
    getPassengers();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/passenger/" + id, {}).then((res) => {
      setData(res.data.passenger);

      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);

  // Hide add modal
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const edit = "passenger";
  const detail = "viewPassenger";

  const notify = () =>
    toast.success("Passengers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: Math.floor(Math.random() * 1000000000000 + 1),
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: Math.floor(Math.random() * 1000000000000 + 1),
    });
  useEffect(() => {
    getPassengers();
  }, []);
 

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        columns: [
          { Header: "ID", accessor: "id" },
          { Header: "First Name", accessor: "firstName" },
          { Header: "Last Name", accessor: "lastName" },
          { Header: "Gender", accessor: "gender" },
        ],
      },
      {
        Header: "Info",
        columns: [
          { Header: "Phone Number", accessor: "phoneNumber" },
          { Header: "Address", accessor: "address" },
          { Header: "Rating", accessor: "rating" },
          { Header: "Miles", accessor: "miles" },
          {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (row) => {
              const status = row.cell.row.original.status || "Active";
              return (
                <Chip 
                  label={status} 
                  color={status === "Active" ? "success" : "warning"}
                  variant="filled"
                  sx={{
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    boxShadow: status === "Active" 
                      ? '0 2px 4px rgba(0,255,0,0.2)' 
                      : '0 2px 4px rgba(255,165,0,0.2)'
                  }}
                />
              );
            },
          },
          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div style={{ 
                display: "flex", 
                gap: "15px", 
                alignItems: 'center' 
              }}>
                {role.filter(e => e.perm_name === "edit_passenger").length > 0 && (
                  <Tooltip title="Edit Passenger">
                    <span>
                      <EditIcon 
                        color="primary" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#1e40af'
                          }
                        }}
                        onClick={() => showEditModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "view_passenger").length > 0 && (
                  <Tooltip title="View Passenger Details">
                    <span>
                      <VisibilityIcon 
                        color="success" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#16a34a'
                          }
                        }}
                        onClick={() => navigate(`/${detail}/${row.cell.row.original.id}`)}
                      />
                    </span>
                  </Tooltip>
                )}
                {role.filter(e => e.perm_name === "delete_passenger").length > 0 && (
                  <Tooltip title="Delete Passenger">
                    <span>
                      <DeleteIcon 
                        color="error" 
                        sx={{ 
                          cursor: 'pointer',
                          transition: 'transform 0.2s',
                          '&:hover': {
                            transform: 'scale(1.2)',
                            color: '#ff0000'
                          }
                        }}
                        onClick={() => showDeleteModal(row.cell.row.original.id)}
                      />
                    </span>
                  </Tooltip>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    [role]
  );


  const columns_expo = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
      },
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "Rating",
        accessor: "rating",
      },
      {
        Header: "Miles",
        accessor: "miles",
      },
    ],
    []
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClickDriver(
      passengers,
      columns_expo,
      selectedColumns,
      "Passengers",
      "passengers.pdf"
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  const printableRefs = useRef(null);

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };
  return (

    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content" ref={printableRef}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                
                <ActionButtons is_all_trips={false} title="List of Passengers" showModal={showModal}/>
                
                  <Modal
                  style={{marginTop: "60px"}}
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={passengers}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        getPassengers={getPassengers}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          getPassengers={getPassengers}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )}
    </div>
    </div>
  );
};
export default SubscriberssList;
